module.exports = "pegasus/assets/blocks/column-16-theme3.png";